const ListChargebackType = () => import('./ListChargebackType.vue')
const NewChargebackType = () => import('./NewChargebackType.vue')
const EditChargebackType = () => import('./EditChargebackType.vue')
const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/admin/chargeback-types',
        name: 'chargebackType',
        component: TheContainer,
        meta: {
            perms: ['admin.chargeback_type.list'],
            breadcrumb: {
                text: 'Dispute Types',
                to: { name: 'chargebackType.list' }
            }
        },
        children: [
            {
                path: '',
                name: 'chargebackType.list',
                component: ListChargebackType,
            },
            {
                path: 'new',
                name: 'chargebackType.new',
                component: NewChargebackType,
                meta: {label: 'Create New'},
            },
            {
                path: ':id',
                name: 'chargebackType.edit',
                component: EditChargebackType,
                meta: {label: 'Edit'},
            },
        ]
    }
]
